import { realBricksApi } from "../../utils/axiosInterceptors";


export const verifySsnAndDobApi = async(data) => {
    const response = await realBricksApi.post(`/api/v1/user/verify-security-identity`, data);
    return response.data;
};

export const forgotPinPasswordLinkApi = async(data) => {
    const response = await realBricksApi.post(`/api/v1/user/forgot-pin-password-link`, data);
    return response.data;
};

export const confirmPinApi = async(data) => {
    const response = await realBricksApi.put(`/api/v1/user/reset-pin`, data);
    return response.data;
};